import React from 'react';

function ArrowDownIcon(props) {
  return (
    <svg viewBox="0 0 24 24" width="24" height="24" {...props}>
      <path d="M7 10l5 5 5-5z" />
    </svg>
  );
}

export default ArrowDownIcon;



// WEBPACK FOOTER //
// ./src/site-render/src/icons/ArrowDownIcon.js